import HCMobileSearchSection from "web/Pages/HelpCenter/Mobile/SearchSection";

import MobileHeader from "web/Layout/MobileHeader";
import __ from "web/Layout/Translations";

import useLangFromParams from "web/hooks/useLangFromParams/useLangFromParams";

import urls from "web/constants/urls";

import HCCategoryBreadcrumbs from "../Shared/Breadcrumbs";
import HCCategoryMobileContent from "./Content";

const HCCategoryMobile = ({ name, articles, prefix }) => {
  const { isParamLangEn } = useLangFromParams();
  return (
    <section>
      <MobileHeader replacementPath={urls.helpCenter}>
        {isParamLangEn ? "Help Center" : __("Centrum pomocy")}
      </MobileHeader>
      <HCCategoryBreadcrumbs name={name} />
      <HCMobileSearchSection />
      <HCCategoryMobileContent
        name={name}
        articles={articles}
        prefix={prefix}
      />
    </section>
  );
};

export default HCCategoryMobile;
